import moment from 'moment';
export default function Bubbles({ data }) {

    return(
        <>
            {
                data.messages && data.messages.map(i => (
                    <div className={`${i.sender.id !== localStorage.getItem('userId') ? 'bg-light' : 'bg-success'} bg-gradient shadow p-3 mb-2`} style={{ borderRadius: 20 }}>
                        <p>{i.message}</p>
                        <small className="text-dark">{ moment(i.datetime.toDate()).format('LLL') }</small>
                    </div>
                ))
            }
        </>
    )
}